<template>
  <auth-page>
    <b-form>
      <form-fail :form-errors="apiErrors.email"/>
      <form-fail :form-errors="apiErrors.other"/>
      <form-success :success="success">
        <p>Thank you for confirming your email.</p>
        <div v-if="authenticated">
          Back to
          <router-link :to="{name: 'home'}">home</router-link>
        </div>
        <div v-else>
          You may now
          <router-link :to="{name: 'login', query: {email: fields.email}}" style="text-decoration:underline">login</router-link>
        </div>
      </form-success>
    </b-form>
  </auth-page>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import authPage from '../../templates/auth-page'
import formFail from '../../common/form/form-fail'
import formSuccess from '../../common/form/form-success'

export default {
  components: {
    authPage,
    formFail,
    formSuccess
  },
  computed: {
    ...mapState('register/forms/confirmEmail', [
      'apiErrors',
      'success',
      'fields'
    ]),
    ...mapGetters({
      authenticated: 'token/authenticated'
    })
  },
  created () {
    if (this.$route.params.token) {
      this.$store.commit('register/forms/confirmEmail/setField', {
        field: 'token',
        value: this.$route.params.token
      })
    }

    if (this.$route.query.email) {
      this.$store.commit('register/forms/confirmEmail/setField', {
        field: 'email',
        value: this.$route.query.email
      })
    }

    this.confirmEmail()

    if (this.authenticated) {
      this.getMe()
    }
  },
  methods: {
    ...mapActions({
      confirmEmail: 'register/confirmEmail',
      getMe: 'client/getMe'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/confirm-email.vue